import { render, staticRenderFns } from "./indicador.vue?vue&type=template&id=f2f0e1f0&scoped=true"
import script from "./indicador.vue?vue&type=script&lang=js"
export * from "./indicador.vue?vue&type=script&lang=js"
import style0 from "./indicador.vue?vue&type=style&index=0&id=f2f0e1f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f0e1f0",
  null
  
)

export default component.exports